import { Button, Group, Stack, Text, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { closeAllModals } from '@mantine/modals';
import { showNotification } from '@mantine/notifications';
import { handleSubmitError } from '@utils/forms';

import { useCreatePasswordlessAdminMutation } from '@api/users.api';

export default function CreatePasswordlessUserForm() {
  // ==========================================================================
  // General
  // ==========================================================================
  const [createUser, { isLoading }] = useCreatePasswordlessAdminMutation();

  // ==========================================================================
  // Form
  // ==========================================================================
  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
  };

  const form = useForm({
    initialValues,
    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Email non valida'),
    },
  });

  const onSubmit = async (values: typeof initialValues) => {
    try {
      await createUser(values).unwrap();

      showNotification({
        title: 'Utente creato',
        message: "L'utente è stato creato con successo",
      });

      closeAllModals();
    } catch (e) {
      handleSubmitError(e, form);
    }
  };

  // ==========================================================================
  // Render
  // ==========================================================================
  return (
    <form
      onSubmit={form.onSubmit((values) => {
        onSubmit(values);
      })}
    >
      <Stack>
        <TextInput
          label="Nome"
          placeholder="Nome"
          required
          data-autofocus
          {...form.getInputProps('firstName')}
        />
        <TextInput
          label="Cognome"
          placeholder="Cognome"
          required
          {...form.getInputProps('lastName')}
        />
        <TextInput
          label="Email"
          placeholder="email@example.com"
          description="L'utente riceverà un'email con il link per impostare la password"
          required
          {...form.getInputProps('email')}
        />
      </Stack>

      {form.errors.general && (
        <Text c="red" size="sm" mt="xl">
          {form.errors.general}
        </Text>
      )}

      <Group justify="end" mt="xl">
        <Button type="submit" loading={isLoading}>
          Conferma
        </Button>
      </Group>
    </form>
  );
}
